module.exports = __webpack_public_path__ + "static/media/T-shirt_skyblue.3808e8a6.svg";